/* @flow */

import { connect } from 'react-redux';
import { withRouter, type RouterHistory } from 'react-router-dom';
import React from 'react';

import { Button, PageContainer } from '@sonyged/ext-proc';

import type { Dispatch } from '../redux/types';
import { hideError } from '../redux/reducer/meta';
import ConnectionErrorIllustration from '../../assets/images/common/error_network@3x.png';

type Props = {
  history: RouterHistory,
  dispatch: Dispatch,
};

const UnrecoverableErrorPage = ({ dispatch, history }: Props) => {
  const goHomeHandle = () => {
    dispatch(hideError());
    history.push('/');
  };

  return (
    <div className="proc-errorPage">
      <PageContainer.normal className="proc-errorPage-container">
        <div className="proc-errorPage-body proc-errorContent">
          <img
            className="proc-errorContent-illustration"
            alt="connection error illustration"
            src={ConnectionErrorIllustration}
          />
          <h2 className="proc-errorContent-title">つうしん できません</h2>
          <p className="proc-errorContent-text">複数タブで利用している可能性があります。</p>
        </div>
        <div className="proc-errorPage-footer">
          <Button.attention className="w100" onClick={goHomeHandle}>
            ホームにもどる
          </Button.attention>
        </div>
      </PageContainer.normal>
    </div>
  );
};

// $FlowFixMe
export default connect()(withRouter(UnrecoverableErrorPage));
